module.exports = "<form name=\"reset\">\r\n    <div class=\"md-form-group\">\r\n        <input type=\"email\" ng-model=\"email\" class=\"md-input\" required>\r\n        <label>Your E-mail</label>\r\n    </div>\r\n    <button type=\"submit\" class=\"btn primary btn-block p-x-md\" data-content=\"Instructions sent to your email.\"\r\n        data-type=\"info\" data-container=\"#alerts-container\" ng-click=\"ctrl.startRestore()\" bs-alert ng-disabled=\"reset.$invalid\">Send</button>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/public/restore/form/component.html
// module id = ./src/app/public/restore/form/component.html
// module chunks = main